import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { ThhHundActions } from '../thhHundActions';

export function* handleThhHundNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    ThhHundActions.HANDLE_THH_HUND_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleThhHundNavigationToAngebot, App.THH_HUND),
  );
}

export function* handleThhHundNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.THH_HUND,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.THH_HUND &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new ThhHundActions().quoteDBRequested());
  yield put(new ThhHundActions().preiseRequested());
  yield put(new ThhHundActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.THH_HUND,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
